/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Timezone,
    TimezoneFromJSON,
    TimezoneFromJSONTyped,
    TimezoneToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeEndpointRequest
 */
export interface TimeEndpointRequest {
    /**
     * 
     * @type {number}
     * @memberof TimeEndpointRequest
     */
    time: number;
    /**
     * 
     * @type {Timezone}
     * @memberof TimeEndpointRequest
     */
    timezone: Timezone;
}

export function TimeEndpointRequestFromJSON(json: any): TimeEndpointRequest {
    return TimeEndpointRequestFromJSONTyped(json, false);
}

export function TimeEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': json['time'],
        'timezone': TimezoneFromJSON(json['timezone']),
    };
}

export function TimeEndpointRequestToJSON(value?: TimeEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'timezone': TimezoneToJSON(value.timezone),
    };
}


